var map = {
	"./auditlog.cattle.io.auditpolicy": 26064,
	"./auditlog.cattle.io.auditpolicy.vue": 26064,
	"./catalog.cattle.io.app": 8842,
	"./catalog.cattle.io.app.vue": 8842,
	"./catalog.cattle.io.clusterrepo": 663,
	"./catalog.cattle.io.clusterrepo.vue": 663,
	"./compliance.cattle.io.clusterscan": 83374,
	"./compliance.cattle.io.clusterscan.vue": 83374,
	"./ext.cattle.io.kubeconfig": 79427,
	"./ext.cattle.io.kubeconfig.vue": 79427,
	"./fleet.cattle.io.bundle": 29269,
	"./fleet.cattle.io.bundle.vue": 29269,
	"./fleet.cattle.io.cluster": 82328,
	"./fleet.cattle.io.cluster.vue": 82328,
	"./fleet.cattle.io.clustergroup": 56966,
	"./fleet.cattle.io.clustergroup.vue": 56966,
	"./fleet.cattle.io.clusterregistrationtoken": 85759,
	"./fleet.cattle.io.clusterregistrationtoken.vue": 85759,
	"./fleet.cattle.io.gitrepo": 35657,
	"./fleet.cattle.io.gitrepo.vue": 35657,
	"./fleet.cattle.io.helmop": 39998,
	"./fleet.cattle.io.helmop.vue": 39998,
	"./group.principal": 86412,
	"./group.principal.vue": 86412,
	"./harvesterhci.io.management.cluster": 54488,
	"./harvesterhci.io.management.cluster.vue": 54488,
	"./helm.cattle.io.projecthelmchart": 75539,
	"./helm.cattle.io.projecthelmchart.vue": 75539,
	"./logging.banzaicloud.io.clusterflow": 34587,
	"./logging.banzaicloud.io.clusterflow.vue": 34587,
	"./logging.banzaicloud.io.flow": 81939,
	"./logging.banzaicloud.io.flow.vue": 81939,
	"./management.cattle.io.cluster": 23104,
	"./management.cattle.io.cluster.vue": 23104,
	"./management.cattle.io.feature": 26611,
	"./management.cattle.io.feature.vue": 26611,
	"./management.cattle.io.fleetworkspace": 97350,
	"./management.cattle.io.fleetworkspace.vue": 97350,
	"./management.cattle.io.oidcclient": 81300,
	"./management.cattle.io.oidcclient.vue": 81300,
	"./management.cattle.io.podsecurityadmissionconfigurationtemplate": 20116,
	"./management.cattle.io.podsecurityadmissionconfigurationtemplate.vue": 20116,
	"./management.cattle.io.setting": 56948,
	"./management.cattle.io.setting.vue": 56948,
	"./management.cattle.io.user": 96646,
	"./management.cattle.io.user.vue": 96646,
	"./monitoring.coreos.com.alertmanagerconfig": 18712,
	"./monitoring.coreos.com.alertmanagerconfig.vue": 18712,
	"./namespace": 87092,
	"./namespace.vue": 87092,
	"./networking.k8s.io.ingress": 48368,
	"./networking.k8s.io.ingress.vue": 48368,
	"./node": 70556,
	"./node.vue": 70556,
	"./persistentvolume": 17581,
	"./persistentvolume.vue": 17581,
	"./persistentvolumeclaim": 70109,
	"./persistentvolumeclaim.vue": 70109,
	"./projectsecret": 91972,
	"./projectsecret.vue": 91972,
	"./provisioning.cattle.io.cluster": 66439,
	"./provisioning.cattle.io.cluster.vue": 66439,
	"./rbac.authorization.k8s.io.clusterrolebinding": 37928,
	"./rbac.authorization.k8s.io.clusterrolebinding.vue": 37928,
	"./secret": 89009,
	"./secret.vue": 89009,
	"./service": 39141,
	"./service.vue": 39141,
	"./ui.cattle.io.navlink": 31395,
	"./ui.cattle.io.navlink.vue": 31395,
	"./workload": 3256,
	"./workload.vue": 3256
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 78967;
module.exports = webpackAsyncContext;